import type { FC } from 'react';
import { DetailHeaderRow } from 'components/DetailHeader/DetailHeader';
import { PaginatedSelector } from 'components/PaginatedSelector/PaginatedSelector';
import React from 'react';

import { Icon } from '@fragment/ui/src/components/Icon';
import { AccountTypeIcon } from '@fragment/ui/src/components/Icon/AccountTypeIcon/AccountTypeIcon';

import type { LinkedLedgerAccount } from './types';

type LinkedLedgerAccountSelectorProps = {
  accounts: LinkedLedgerAccount[];
  selected: LinkedLedgerAccount | undefined;
  setSelected: (value?: LinkedLedgerAccount) => void;
  loadMore?: VoidFunction;
  fetching?: boolean;
  getPath: (value: LinkedLedgerAccount) => string;
};

const renderRow = (row: LinkedLedgerAccount) => (
  <div className="flex flex-row justify-between space-x-f2 w-full">
    <div className="flex flex-row items-center justify-start flex-grow truncate">
      <AccountTypeIcon type={row.type} />
      <span className="truncate">{row.name}</span>
    </div>
    <span>{row.ledger.name}</span>
  </div>
);

export const LinkedLedgerAccountSelector: FC<
  LinkedLedgerAccountSelectorProps
> = ({ accounts, selected, setSelected, loadMore, fetching, getPath }) => {
  if (selected === undefined) {
    return null;
  }

  return (
    <PaginatedSelector<LinkedLedgerAccount>
      data={accounts}
      selected={selected}
      onChange={setSelected}
      loadMore={loadMore}
      fetching={fetching}
      renderRow={renderRow}
    >
      {(renderSelector) => (
        <div className="relative w-full">
          <DetailHeaderRow
            label="Ledger Account"
            value={renderSelector(
              <div className="flex flex-row items-center justify-start flex-grow truncate">
                <AccountTypeIcon type={selected.type} />
                <span className="truncate mr-[1ch]">{selected.name}</span>
                <Icon type="select" size="md" primaryColor="gray" />
              </div>
            )}
          />
        </div>
      )}
    </PaginatedSelector>
  );
};
